import { render, staticRenderFns } from "./DataManagement.vue?vue&type=template&id=3a87c6a4&scoped=true"
import script from "./DataManagement.vue?vue&type=script&lang=js"
export * from "./DataManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87c6a4",
  null
  
)

export default component.exports